<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/projectmanagement/index">Manage Project</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        {{ project.project_name || "View Project" }}
      </h6>

      <div class="container-fluid">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <!-- <button @click="goToUpdate" class="btn btn-sm btn-outline-primary mb-1 bdr-rad">
            Update
          </button> -->
        </div>

        <div class="card custom_bdr_rds shadow p-2" v-if="loading">
          <div class="card-body custom_bdr_rds">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="mt-1" style="padding-bottom: 100px">
          <div class="card custom_bdr_rds shadow p-2 mb-3">
            <div class="card-body custom_bdr_rds">
              <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                <tbody>
                  <tr>
                    <td class="width-custom2"><b>Project Name</b></td>
                    <td>{{ project.project_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Project Description</b></td>
                    <td>{{ project.project_description || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Sponsor</b></td>
                    <td>{{ project.sponsor_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Site</b></td>
                    <td>{{ project.site || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>CRC</b></td>
                    <td>{{ project.crc_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Investigators</b></td>
                    <td>{{ investigatorNames }}</td>
                  </tr>
                  <tr>
                    <td><b>Number of Visit</b></td>
                    <td>{{ project.number_of_visit || 0 }}</td>
                  </tr>
                  <tr>
                    <td><b>Screening Date</b></td>
                    <td>{{ formatDate(project.screening_date) }}</td>
                  </tr>
                  <tr>
                    <td><b>Status</b></td>
                    <td>{{ project.status === 1 ? "Active" : "Inactive" }}</td>
                  </tr>
                  <tr>
                    <td><b>Created Date</b></td>
                    <td>{{ project.created_date || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Created By</b></td>
                    <td>{{ project.created_by || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-1"><b>Visit Schedule</b></h6>
 <div class="mb-1 screening-date-box">
                <label class="custom-label mb-1" style="font-size: small;"><b>Screening Date</b></label>
                <div class="form-control bdr-rad font-size_def bg-white">
                  {{ formatDate(project.screening_date) }}
                </div>
              </div>
              <div class="table-responsive">
                <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                  <thead class="background_color2">
                    <tr class="custom-label2">
                      <th style="width: 8%;">#</th>
                      <th style="width: 16%;">Treatment Phase</th>
                      <th style="width: 38%;">Description</th>
                      <th style="width: 18%;">Date</th>
                      <th style="width: 20%;">Allowed Deviation +/- Days</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in project.visit_schedule || []" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ formatTreatmentPhase(row) }}</td>
                      <td>{{ row.description || "-" }}</td>
                      <td>{{ formatDate(row.date) }}</td>
                      <td>{{ formatDeviation(row.allowed_deviation_days) }}</td>
                    </tr>
                    <tr v-if="!(project.visit_schedule || []).length">
                      <td colspan="5" class="text-center text-muted">No visit schedule found.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

             
            </div>
          </div>

          <div class="card custom_bdr_rds shadow p-2 mt-3">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-1"><b>Visit Reporting</b></h6>

              <div v-if="visitReportLoading" class="d-flex justify-content-center py-3">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div v-else class="table-responsive">
                <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                  <thead class="background_color2">
                    <tr class="custom-label2">
                      <th>#</th>
                      <th>Report Code</th>
                      <th>Project</th>
                      <th>Patient</th>
                      <th>Site</th>
                      <th>Screening Date</th>
                      <th class="text_right">Rows</th>
                      <th class="text_right">Completed Visits</th>
                      <th class="text_right">Created Date</th>
                      <th class="text_right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in visitReportRows" :key="row.report_batch_code || index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ row.report_batch_code || "-" }}</td>
                      <td>{{ row.project_name || "-" }}</td>
                      <td>{{ row.patient_code || "-" }}</td>
                      <td>{{ row.site || "-" }}</td>
                      <td>{{ formatDate(row.screening_date) }}</td>
                      <td class="text_right">{{ row.row_count || 0 }}</td>
                      <td class="text_right">{{ row.completed_visit_count || 0 }}</td>
                      <td class="text_right">{{ row.created_date || "-" }}</td>
                      <td class="text_right">
                        <router-link :to="'/projectmanagement/visitview?code=' + row.report_batch_code" class="btn btn-sm btn-outline-primary bdr-rad">
                          View
                        </router-link>
                      </td>
                    </tr>
                    <tr v-if="!visitReportRows.length">
                      <td colspan="10" class="text-center text-muted">No visit reports found.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: {
    ContentFooter,
    TopNavbar,
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      id: this.$route.query.id || null,
      loading: false,
      visitReportLoading: false,
      visitReportRows: [],
      project: {
        visit_schedule: [],
        investigator_names: [],
      },
    };
  },

  computed: {
    investigatorNames() {
      return Array.isArray(this.project.investigator_names) && this.project.investigator_names.length
        ? this.project.investigator_names.join(", ")
        : "-";
    },
  },

  mounted() {
    this.loadProject();
    this.loadVisitReports();
  },

  methods: {
    goToUpdate() {
      this.$router.push("/projectmanagement/create?id=" + this.id);
    },

    formatDate(value) {
      if (!value) {
        return "-";
      }

      const [year, month, day] = String(value).split("-");
      return year && month && day ? `${day}/${month}/${year}` : value;
    },

    formatDeviation(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "-";
      }

      const normalized = String(value).trim();

      if (!normalized) {
        return "-";
      }

      if (normalized === "0" || normalized === "+0" || normalized === "-0" || normalized === "+/- 0") {
        return "-";
      }

      if (normalized.startsWith("+") || normalized.startsWith("-")) {
        return normalized;
      }

      const parsed = parseInt(normalized, 10);

      if (Number.isNaN(parsed)) {
        return normalized;
      }

      return parsed > 0 ? `+${parsed}` : String(parsed);
    },

    formatTreatmentPhase(row) {
      const label = row && row.treatment_phase_label ? String(row.treatment_phase_label).trim() : "";

      if (label) {
        return label;
      }

      if (row && row.treatment_phase !== null && row.treatment_phase !== "") {
        return row.treatment_phase;
      }

      return "-";
    },

    async loadVisitReports() {
      this.visitReportLoading = true;

      try {
        const { data } = await axios.get("/projectvisit/indexload", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        const allRows = data.status === 200 && Array.isArray(data.data) ? data.data : [];
        this.visitReportRows = allRows.filter((row) => Number(row.project_id || 0) === Number(this.id || 0));
      } catch (error) {
        console.error(error.response || error);
        this.visitReportRows = [];
      } finally {
        this.visitReportLoading = false;
      }
    },

    async loadProject() {
      if (!this.id) {
        return;
      }

      this.loading = true;

      try {
        const { data } = await axios.get("/projectmanagement/view?id=" + this.id, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200) {
          this.project = data.data || this.project;
        } else {
          alert(data.message || "Error loading project details.");
        }
      } catch (error) {
        console.error(error.response || error);
        alert("Error loading project details.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.screening-date-box {
  width: 100%;
  max-width: 240px;
}
</style>
